<svg xmlns="http://www.w3.org/2000/svg" viewBox="20 20 60 60">
  <path d="M37.5,44.999c-2.758,0-5.001,2.243-5.001,5.001c0,2.757,2.243,5,5.001,5c2.757,0,5-2.243,5-5  C42.5,47.242,40.257,44.999,37.5,44.999z"/>
  <path d="M62.501,44.999c-2.758,0-5.001,2.243-5.001,5.001c0,2.757,2.243,5,5.001,5c2.757,0,5-2.243,5-5  C67.501,47.242,65.258,44.999,62.501,44.999z"/>
  <path d="M50,20c-16.542,0-30,13.458-30,30s13.458,30,30,30s30-13.458,30-30S66.542,20,50,20z M50,75c-13.785,0-25-11.215-25-25  s11.215-25,25-25s25,11.215,25,25S63.785,75,50,75z"/>
</svg>
